<template>
    <v-app>
        <v-navigation-drawer
            app
            v-model="drawer"
            dark
            v-bind="{permanent: $vuetify.breakpoint.mdAndUp}"
            touchless
            width="210"
        >
            <v-toolbar flat dense>
                <v-list dense>
                    <v-list-tile>
                        <v-list-tile-avatar dense size="32">
                            <img src="baseball-diamond-32x32.png" style="border-radius:5px;" alt />
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title class="title">NLMF</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-toolbar>
            <v-list dense>
                <v-list-tile
                    v-for="item in menuItems"
                    v-bind:key="item.title"
                    v-bind:to="item.link"
                >
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile
                    v-for="item in adminMenuItems"
                    v-bind:key="item.title"
                    v-bind:to="item.link"
                >
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <template v-if="isAuthenticated">
                    <v-divider></v-divider>
                    <v-list-tile v-on:click="logout" active-class="none">
                        <v-list-tile-action>
                            <v-icon>logout</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>Logout</v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar app flat dense dark>
            <v-toolbar-side-icon class="hidden-md-and-up" v-on:click="drawer = !drawer"></v-toolbar-side-icon>
            <img
                class="hidden-md-and-up"
                src="baseball-diamond-32x32.png"
                style="border-radius:5px;"
                alt
            />
            <v-toolbar-title class="hidden-md-and-up">NLMF</v-toolbar-title>
            <v-spacer class="hidden-md-and-up"></v-spacer>
            <template v-if="menuSelectedSeason">
                <v-menu v-bind:nudge-width="100">
                    <template v-slot:activator="{ on }">
                        <v-toolbar-title v-on="on">
                            <span>{{selectedSeason.season}}</span>
                            <v-icon>arrow_drop_down</v-icon>
                        </v-toolbar-title>
                    </template>
                    <v-list>
                        <v-list-tile
                            v-for="season in seasons"
                            v-bind:key="season.id"
                            v-on:click="changeSelectedSeason(season)"
                        >
                            <v-list-tile-title>{{season.season}}</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </template>
        </v-toolbar>
        <v-content>
            <router-view></router-view>
        </v-content>
        <v-footer class="justify-center">
            <div>Last updated: {{ getLastUpdateTime }}</div>
        </v-footer>
        <snackbar></snackbar>
    </v-app>
</template>

<script>
import { auth } from './main'
import Snackbar from './components/Snackbar'

export default {
    name: 'App',
    data() {
        return {
            drawer: false,
            menuSelectedSeason: null
        }
    },
    created() {
        // Determine client platform.
        let platform = window.navigator.platform
        let os

        if (
            /iOS/.test(platform) ||
            /iPhone/.test(platform) ||
            /iPad/.test(platform) ||
            /iPod/.test(platform) ||
            /Mac/.test(platform) ||
            /Darwin/.test(platform) ||
            /OSX/.test(platform) ||
            /OS X/.test(platform)
        ) {
            os = 'Apple'
        } else if (/Android/.test(platform)) {
            os = 'Android'
        } else if (/Win/.test(platform)) {
            os = 'Windows'
        } else if (/Linux/.test(platform)) {
            os = 'Linux'
        } else {
            os = 'Unknown'
            console.log(`Unknown platform: ${platform}`)
        }

        this.$store.commit('setClientPlatform', os)

        // Load data from Firebase Firestore into Vuex.
        // Need to ensure seasons are loaded first into Vuex.
        this.$store.dispatch('loadSeasonData').then(() => {
            this.$store.dispatch('loadTeamData')
            this.$store.dispatch('loadDivisionData')
            this.$store.dispatch('loadMatchData')
            this.$store.dispatch('loadPlayoffRoundsData')
            this.$store.dispatch('loadPlayoffMatchupsData')
            this.$store.dispatch('loadPlayoffMatchesData')
            this.$store.dispatch('loadPlayersData')
            this.$store.dispatch('loadPlayersStatsData')
            this.$store.dispatch('loadRostersData')
            this.$store.dispatch('loadPlayersPositionsData')
            this.$store.dispatch('loadLocationsData')
        })

        auth.onAuthStateChanged((user) => {
            if (user) {
                this.$store.commit('setUser', user)
                this.$store.commit('setIsAuthenticated', true)
            } else {
                this.$store.commit('setUser', null)
                this.$store.commit('setIsAuthenticated', false)
            }
            this.$store.commit('setFirebaseAuthLoaded', true)
        })
    },
    methods: {
        logout() {
            this.$store.dispatch('userLogout')
        },
        changeSelectedSeason(season) {
            let selectedSeason = this.$store.getters.getSeasonById(season.id)
            this.$store.commit('setSelectedSeason', selectedSeason)
            // Load the data for the newly selected season.
            this.$store.dispatch('loadDivisionData')
            this.$store.dispatch('loadMatchData')
            this.$store.dispatch('loadPlayoffRoundsData')
            this.$store.dispatch('loadPlayoffMatchupsData')
            this.$store.dispatch('loadPlayoffMatchesData')
            this.$store.dispatch('loadPlayersData')
            this.$store.dispatch('loadPlayersStatsData')
            this.$store.dispatch('loadRostersData')
            this.$store.dispatch('loadPlayersPositionsData')
        },
        adminRoute() {
            if (this.$router.currentRoute.fullPath.includes('admin')) {
                return true
            } else {
                return false
            }
        }
    },
    computed: {
        menuItems() {
            let items = []

            items.push({ title: 'Standings', link: '/standings', icon: 'view_list' })
            items.push({ title: 'Schedule', link: '/schedule', icon: 'date_range' })
            items.push({ title: 'Statistics', link: '/statistics', icon: 'insights' })
            items.push({ title: 'Playoffs', link: '/playoffs', icon: 'emoji_events' })
            items.push({ title: 'Teams', link: '/teams', icon: 'workspaces' })
            items.push({ title: 'Rosters', link: '/rosters', icon: 'group' })
            items.push({ title: 'Calendar', link: '/calendar', icon: 'calendar_today' })
            items.push({ title: 'Info', link: '/info', icon: 'info' })

            return items
        },
        adminMenuItems() {
            let items = []

            items.push({ title: 'Administration', link: '/admin', icon: 'build' })
            // if (this.isAuthenticated) {
            //     items.push({ title: 'Logout', icon: 'logout' })
            // }

            return items
        },
        isAuthenticated() {
            return this.$store.state.isAuthenticated
        },
        getLastUpdateTime() {
            let matches = this.$store.state.matches
            let playoffRounds = this.$store.state.playoffRounds
            let playoffMatchups = this.$store.state.playoffMatchups
            let playoffMatches = this.$store.state.playoffMatches

            let mostCurrentDate = this.$moment('1970-01-01')

            matches.forEach((match) => {
                let updated_at = this.$moment.unix(match.updated_at.seconds)
                if (this.$moment(updated_at).isAfter(mostCurrentDate)) {
                    mostCurrentDate = updated_at
                }
            })

            playoffRounds.forEach((round) => {
                let updated_at = this.$moment.unix(round.updated_at.seconds)
                if (this.$moment(updated_at).isAfter(mostCurrentDate)) {
                    mostCurrentDate = updated_at
                }
            })

            playoffMatchups.forEach((matchup) => {
                let updated_at = this.$moment.unix(matchup.updated_at.seconds)
                if (this.$moment(updated_at).isAfter(mostCurrentDate)) {
                    mostCurrentDate = updated_at
                }
            })

            playoffMatches.forEach((match) => {
                let updated_at = this.$moment.unix(match.updated_at.seconds)
                if (this.$moment(updated_at).isAfter(mostCurrentDate)) {
                    mostCurrentDate = updated_at
                }
            })

            return mostCurrentDate.format('YYYY-MM-DD HH:mm')
        },
        seasons() {
            return this.$store.getters.getSortedSeasons
        },
        selectedSeason() {
            return this.$store.state.selectedSeason
        }
    },
    watch: {
        seasons() {
            this.menuSelectedSeason = this.$store.state.currentSeason
        }
    },
    components: {
        Snackbar
    }
}
</script>

<style lang="scss" scoped>
a {
    color: white;
    text-decoration: none;
}
</style>
